export const newToOldTranslationKeys = {
  ui_label_contractNumber: 'fEmpContractNumber',
  ui_label_employeeNumber: 'fEmployeeNumberInput',
  ui_label_legalEntity: 'laLegalEntity',
  ui_label_position: 'laPosition',
  ui_label_businessTitle: 'laBusinessTitle',
  ui_label_organizationUnits: 'laOrgUnits',
  ui_label_unitPositions: 'fEmpUnitPositions',
  ui_label_costCenter: 'laCostCenter',
  ui_label_manager: 'laManager',
  ui_label_hrResponsibilityOver: 'laHRResponsibility',
  ui_label_managerResponsibilityOver: 'laMgrResponsibility',
  ui_label_employmentType: 'laEmploymentType',
  ui_label_employmentStatus: 'laEmploymentStatus',
  ui_label_employmentStartDate: 'fEmploymentStartDateInput',
  ui_label_arrivalDate: 'fArrivalDate',
  ui_label_trialPeriod: 'fTrialPeriod',
  ui_label_trialPeriodEnds: 'laTrialPeriodEndDate',
  ui_label_reasonForFixedTerm: 'fFixedTermReasonInput',
  ui_label_jobGrade: 'laJobGrade',
  ui_label_taxNumber: 'laTaxNumber',
  ui_label_vacationBalanceCalculation: 'fVacationBalanceCalculationInputLabel',
};

export type NewTranslationKeys = keyof typeof newToOldTranslationKeys;

export * from './slice';
export * from './types';
